<template>
    <div id="formulario-agenda">
        <div class="row">
            <div class="input-field col s12">
                <input id="agenda_nome" type="text" v-model="formData.agenda_nome">
                <label for="agenda_nome" :class="checkValue(formData.agenda_nome)">Título</label>
            </div>
        </div>
        <div class="row">
            <div class="input-field col s12 m3 l3">
                <masked-input type="text" id="agenda_data" v-model="formData.agenda_data" mask="11/11/1111" />
                <label for="agenda_data" :class="checkValue(formData.agenda_data)">Data início</label>
            </div>
            <div class="input-field col s12 m3 l3">
                <masked-input type="text" id="agenda_hora" v-model="formData.agenda_hora" mask="11:11" />
                <label for="agenda_hora" :class="checkValue(formData.agenda_hora)">Horário início</label>
            </div>

            <div class="input-field col s12 m3 l3">
                <masked-input type="text" id="agenda_data_fim" v-model="formData.agenda_data_fim" mask="11/11/1111" />
                <label for="agenda_data_fim" :class="checkValue(formData.agenda_data_fim)">Data fim</label>
            </div>
            <div class="input-field col s12 m3 l3">
                <masked-input type="text" id="agenda_hora_fim" v-model="formData.agenda_hora_fim" mask="11:11" />
                <label for="agenda_hora_fim" :class="checkValue(formData.agenda_hora_fim)">Horário fim</label>
            </div>
        </div>
        <div class="row">
            <div class="col s12 m12">
                <gmap-input
                    id="agenda_endereco"
                    :field-name="'agenda_endereco'"
                    :end="formData.agenda_endereco"
                    :latitude="formData.agenda_endereco_latitude"
                    :longitude="formData.agenda_endereco_longitude"
                    @newgmapdata="handleDataGmap($event)">
                </gmap-input>
            </div>
        </div>
        <div class="row">
            <div class="col s12 m6 l6" v-if="checaCargoUsuario([cargoDono, cargoGerente, cargoEspecialista])">
                <label for="funcionario_id">Responsável pela tarefa</label>
                <select class="browser-default" v-model="formData.funcionario_id" id="funcionario_id">
                    <option value="" disabled selected>Selecione um funcionário</option>
                    <option
                        :key="funcionario.funcionario_id"
                        :value="funcionario.funcionario_id"
                        v-for="funcionario in funcionarios"
                    >
                        {{ funcionario.pessoa.pessoa_nome }}
                    </option>
                </select>
            </div>
            <div class="col s12 m6">
                <label for="notificar_minutos_antes">Notificar antes de quantos minutos?</label>
                <select class="browser-default" v-model="formData.notificar_minutos_antes" id="notificar_minutos_antes">
                    <option
                        :key="minutosAntesOption.value"
                        :value="minutosAntesOption.value"
                        v-for="minutosAntesOption in minutosAntesOptions"
                    >
                        {{ minutosAntesOption.label }}
                    </option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="input-field col s12 m12 l12">
                <textarea class="materialize-textarea" v-model="formData.agenda_descricao" id="agenda_descricao"></textarea>
                <label for="agenda_descricao" :class="checkValue(formData.agenda_descricao)">Descrição</label>
            </div>
        </div>
    </div>
</template>
<style>

#funcionario_id option{
    text-transform: uppercase !important;
}
</style>

<script>
    import { get, post } from '@/helpers/api';
    import MaskedInput from 'vue-masked-input';
    import { DONO, GERENTE, ESPECIALISTA, CORRETOR } from '@/constants/funcionarioCargo.js';
    import Auth from '@/store/auth';
    import GmapInput from '../common/GmapInput.vue';

    export default {
        components: {
            MaskedInput,
            GmapInput
        },
        props: ['agenda'],
        data: () => ({
            formData: {
                agenda_nome: '',
                agenda_data: moment().format('DD/MM/YYYY'),
                agenda_hora: moment().format('HH:mm'),
                funcionario_id: '',
                agenda_endereco: '',
                agenda_endereco_latitude: '',
                agenda_endereco_longitude: '',
                agenda_descricao: '',
                agenda_data_fim: moment().format('DD/MM/YYYY'),
                agenda_hora_fim: moment().format('HH:mm'),
                notificar_minutos_antes: '',
            },
            usuarioLogadoCargo: null,
            cargoDono: null,
            cargoGerente: null,
            cargoCorretor: null,
            cargoEspecialista: null,
            funcionarios: [],
            minutosAntesOptions: [
                {
                    label: 'Não notificar',
                    value: '',
                },
                {
                    label: '5 minutos',
                    value: 5,
                },
                {
                    label: '15 minutos',
                    value: 15,
                },
                {
                    label: '30 minutos',
                    value: 30,
                },
                {
                    label: '1 hora',
                    value: 60,
                },
                {
                    label: '2 horas',
                    value: 60 * 2,
                },
                {
                    label: '6 horas',
                    value: 60 * 6,
                },
                {
                    label: '1 dia',
                    value: 60 * 24,
                },
            ],
        }),
        created() {
            if (this.agenda) {
                let data = this.agenda.agenda_data;
                let dataFim = this.agenda.agenda_data_fim;
                this.formData.agenda_nome = this.agenda.agenda_nome;
                this.formData.agenda_data = moment(data).format('DD/MM/YYYY');
                this.formData.agenda_hora = moment(data).format('HH:mm');
                this.formData.funcionario_id = this.agenda.funcionario_id;
                this.formData.agenda_endereco = this.agenda.agenda_endereco;
                this.formData.agenda_endereco_latitude = this.agenda.agenda_endereco_latitude;
                this.formData.agenda_endereco_longitude = this.agenda.agenda_endereco_longitude;
                this.formData.agenda_descricao = this.agenda.agenda_descricao;
                this.formData.agenda_data_fim = moment(dataFim).format('DD/MM/YYYY');
                this.formData.agenda_hora_fim = moment(dataFim).format('HH:mm');
                this.formData.notificar_minutos_antes = this.agenda.notificar_minutos_antes;
            }

            this.usuarioLogadoCargo = Auth.getCargoUsuario();
            this.cargoDono = DONO;
            this.cargoGerente = GERENTE;
            this.cargoCorretor = CORRETOR;
            this.cargoEspecialista = ESPECIALISTA;

            let self = this;
            get('funcionario').then(function (response) {
                 self.funcionarios = response.data.result.data;
            });
        },
        methods: {
            checaCargoUsuario(arrayPode) {
                return arrayPode.indexOf(this.usuarioLogadoCargo) !== -1;
            },
            checkValue(value) {
                if (value !== '') {
                    return 'active';
                }
                return '';
            },
            getAddressData(data) {
                // console.log(data);
            },
            handleDataGmap(e) {
                [
                    this.formData.agenda_endereco,
                    this.formData.agenda_endereco_latitude,
                    this.formData.agenda_endereco_longitude
                ] = e;
            },
        },
        watch: {
            formData: {
                handler: function() {
                    this.$emit('newdata', [
                        this.formData.agenda_nome,
                        this.formData.agenda_data,
                        this.formData.agenda_hora,
                        this.formData.funcionario_id,
                        this.formData.agenda_endereco,
                        this.formData.agenda_endereco_latitude,
                        this.formData.agenda_endereco_longitude,
                        this.formData.agenda_descricao,
                        this.formData.agenda_data_fim,
                        this.formData.agenda_hora_fim,
                        this.formData.notificar_minutos_antes,
                    ]);
                },
                deep: true
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/agenda/Formulario.vue